import { TableContainer, TableHeader } from '@occc/ui-design-system';
import { useGetDisplayCategories } from '@occc-app/dataAccessLayer/displayCategory/queries';
import { usePaginationParams } from '@occc-app/hooks/usePaginationParams';

import { DisplayCategoriesTable } from './DisplayCategoriesTable';

export const DisplayCategoriesTableContainer = () => {
  const [paginationInfo, onPageChange] = usePaginationParams();

  const { loading, error, data, paginationProps } = useGetDisplayCategories({
    paginationInfo,
    onPageChange,
  });

  return (
    <TableContainer>
      <TableHeader title='Display Categories' />
      <DisplayCategoriesTable
        displayCategories={data}
        loading={loading}
        error={error}
        paginationProps={paginationProps}
      />
    </TableContainer>
  );
};
